import { render, staticRenderFns } from "./InvoiceItemList.vue?vue&type=template&id=3ef8e562&scoped=true&"
import script from "./InvoiceItemList.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItemList.vue?vue&type=style&index=0&id=3ef8e562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef8e562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCheckbox,
  VDataTable,
  VSpacer,
  VTextField,
})
